<div class="view-instructions-button button" (click)="openCollectionInstructions()">See collection instructions</div>
<a class="print-button button" *ngIf="labelUrl" [href]="labelUrl">
  <common-download-icon class="icon"></common-download-icon>
  Download label
</a>
